import type { UserVehicleData, VehicleData } from '@oneaudi/user-vehicle-feature-service';

interface HasPwd {
  hasPwd: boolean;
}
const useHasPwdVehicle = (userVehicles: UserVehicleData[] | null): HasPwd => {
  if (!userVehicles) {
    return { hasPwd: false };
  }

  const vehicleList: VehicleData[] = [];
  userVehicles.map((vehicle: UserVehicleData) => {
    if (vehicle.vehicle) {
      vehicleList.push(vehicle.vehicle);
    }
  });
  const hasPwd = vehicleList.some((val) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return val.pdw?.pdwVehicle ?? false;
  });
  return { hasPwd };
};

export default useHasPwdVehicle;
